import { createTheme, Theme, ThemeOptions } from "@mui/material/styles";

const lightThemeDef: ThemeOptions = {
  palette: {
    background: {
      default: "#f6f8fa",
      paper: "#ffffff",
    },
    primary: {
      main: "#00838F",
      dark: "#006064",
      light: "#2D3843",
      contrastText: "#FFF",
    },
    secondary: {
      main: "#CFD8DC",
      light: "#ECEFF1",
      contrastText: "#455A64",
    },
    error: {
      main: "#D32F2F",
      dark: "#C62828",
      contrastText: "#FFF",
    },
    warning: {
      main: "#F57C00",
      dark: "#EF6C00",
      contrastText: "#FFF",
    },
    success: {
      main: "#2E7D32",
      dark: "#1B5E20",
      contrastText: "#FFF",
    },
    info: {
      main: "#0288D1",
      dark: "#01579B",
      contrastText: "#FFF",
    },
  },
  typography: {
    fontFamily: ["Inter", "Arial", "sans-serif"].join(", "),
  },
};

export const createCustomTheme = (): Theme => {
  return createTheme({ ...lightThemeDef });
};

export const AvatarColors: string[] = ["#B0BEC5"];

export default createCustomTheme;
